<template>
  <div>
    <v-dialog v-model="show" width="500px">
      <v-card>
        <v-container>
          <v-card-title>
            <v-col cols="12">
              <label>Upload Images</label>
              <div class="form-group">
                <input type="file" @change="uploadFile" multiple />
              </div>
            </v-col>
          </v-card-title>
          <v-card-actions>
            <v-btn rounded color="info" @click="uploadToServer">Insert</v-btn>
            <v-btn rounded color="secondary" @click="clearImage">Cancel</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "ProjectImageAdd",
  props: ["imageAdd"],
  components: {},
  computed: {
    show: {
      get() {
        return this.imageAdd;
      },
      set(show) {
        this.$emit("update-add-image-modal", show);
      },
    },
  },
  data() {
    return {
      imageData: [],
      timeout: 3000,
    };
  },
  methods: {
    ...mapActions([
      "showLoadingProcess",
      "closeLoading",
      "CreateProjectImage",
      "UploadProjectImage",
      "showSnackBar",
      "closeSnackBar",
    ]),
    async uploadFile(event) {
      this.imageData = event.target.files;
    },
    async uploadToServer() {
      let formData = new FormData();
      for (const i of Object.keys(this.imageData)) {
        formData.append("file", this.imageData[i]);
      }
      try {
        await this.showLoadingProcess();
        const value = {
          project_id: this.$route.query.project_id,
          image_id: [],
        };
        try {
          value.image_id = await this.UploadProjectImage(formData);
          this.showSnackBar(true, `Upload Image Success`, "success");
          setTimeout(async () => {
            await this.closeSnackBar();
          }, this.timeout);
        } catch (err) {
          console.log(JSON.stringify(err));
          await this.showSnackBar({text: JSON.stringify(err), color: "error"});
          setTimeout(async () => {
            await this.closeSnackBar();
          }, this.timeout);
        }
        await this.CreateProjectImage(value);
        this.clearImage();
        await this.closeLoading();
        this.showSnackBar(true, `Image has be added to Project`, "success");
        setTimeout(async () => {
          await this.closeSnackBar();
        }, this.timeout);
      } catch (err) {
        console.log(JSON.stringify(err));
        this.clearImage();
        await this.closeLoading();
        await this.showSnackBar({text: JSON.stringify(err), color: "error"});
        setTimeout(async () => {
          await this.closeSnackBar();
        }, this.timeout);
      }
    },
    clearImage() {
      this.show = false;
      this.imageData = [];
    },
    updateSnackBarProp(value) {
      this.snackbar = value;
    },
    showSnackBar(toggle, text, color) {
      this.snackbar = toggle;
      this.text = text;
      this.color = color;
    },
  },
};
</script>

<style scoped></style>
